
export default class BankAccountFundAutomaticBackupResponseModel {
    public fundId: number = 0;
    public fundName: string = '';
    public debits: number = 0;
    public credits: number = 0;
    public balance: number = 0;
}
